'use client';

export default function GlobalError() {
	return (
		// Do not need the lang because its auto added

		<html>
			<body>
				<div className="min-h-full w-full bg-white">
					<header className="border-grey-darkest flex h-32 w-full items-center border-b bg-white pl-6">
						<img src="/images/Brand.jpg" alt="Krispy Kreme Doughnuts" className="max-w-xs" />
					</header>
					<main className="m-auto max-w-screen-md p-6 text-center">
						<img src="/images/Error Desktop.png" alt="Oh no" className="mx-auto mb-8 max-w-sm" />
						<h1
							className="mb-4 uppercase"
							data-type-style="title-1"
							style={{ color: 'var(--color-green-300)' }}
						>
							We may be down but we are not out!
						</h1>
						<p className="mx-auto mb-8 max-w-lg break-words text-base font-medium uppercase">
							While our website is taking a sweet break, our delicious doughnuts are still available
							for delivery!
						</p>
						<div className="mx-auto mt-4 flex max-w-xs justify-between">
							<a href="https://www.doordash.com/business/Krispy-Kreme-Doughnuts-1164/">
								<img
									src="/images/DoorDash Desktop.png"
									className="w-full"
									alt="Order from DoorDash"
								/>
							</a>
							<a href="https://www.ubereats.com/brand/krispy-kreme">
								<img
									src="/images/UberEats Desktop.png"
									className="w-full"
									alt="Order from Uber Eats"
								/>
							</a>
						</div>
					</main>
				</div>
			</body>
		</html>
	);
}
